export default function Icon({ children, top = 0, right = 0 }) {
  const style = {
    position: "absolute",
    top,
    right,
  };
  return <div style={style}>{children}</div>;
}
